import styled from "styled-components";
import { Flex } from "../layout";

export const Content = styled(Flex)`
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
  flex-direction: column;
  align-items: stretch;
  margin: 2em 0;
`;

export const CTAWrapper = styled(Flex)`
  justify-content: flex-end;
`;
